import { render, staticRenderFns } from "./channel_list.vue?vue&type=template&id=5498e5f7&"
import script from "./channel_list.vue?vue&type=script&lang=js&"
export * from "./channel_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports